import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';

const MoreMenuItem = ({ Icon, text, pathname, search, count, onClickButton, onClickLink, isNew }) => {
  const { t } = useTranslation();

  return pathname ? (
    <NavLink
      className={styles.moreMenuItem}
      onClick={onClickLink}
      to={{
        pathname: pathname,
        search: search ? search : '',
      }}
    >
      <Icon />
      {text}
      {isNew && <div className={`${styles.menuItemLabel} ${styles.moreMenuItemLabel}`}>{t('nav.new')}</div>}
    </NavLink>
  ) : (
    onClickButton && (
      <Button className={styles.moreMenuItem} type="text" icon={<Icon />} onClick={onClickButton}>
        {text}
        {count ? <span className={'count'}>{count}</span> : ''}
      </Button>
    )
  );
};

export default MoreMenuItem;
